import { BrowserRouter, Routes, Route, Navigate } from 'react-router-dom';
import JewelryLogin from '../src/pages/Login';
import Layout from './components/Layout';
import BarcodeScanPopup from "../src/components/BarcodeScanPopup";
import PublicCatalogue from "./pages/PublicCatalogue";

function App() {
  return (
    <BrowserRouter>
      <Routes>
        <Route path="/" element={<JewelryLogin />} />
        <Route path="/catalogue" element={<PublicCatalogue />} />
        <Route path="/catalogue/:id" element={<PublicCatalogue />} />
        <Route path="/dashboard" element={
          <>
            <BarcodeScanPopup />
            <Layout />
          </>
        } />
        <Route path="*" element={<Navigate to="/" />} />
      </Routes>
    </BrowserRouter>
  );
}

export default App;